export default __webpack_public_path__ + "static/media/f_wdt_c_0_1.94380aef.mp3";